 <template>
  <div>
    <div class="border-bottom border-warning pb-2">
      <b style="font-size: 15px !important" class="text-dark">انتخاب درگاه پرداخت</b>
    </div>
    <!-- <div class="alert bg-dark-Custom text-center w-100 mt-2">
                <b class="text-warning" style="font-size:15px !important;">انتخاب درگاه ، </b>
                <span class="text-light">پس از اطمینان حاصل کردن از اطلاعات وارد شده ، یکی از درگاه های زیر رانتخاب و بر روی دکمه واریز کلیک کنید</span>
            </div> -->
    <div>
      <span class="" v-for="dargah in ListDargah" :key="dargah.id">
        <img v-if="GetDay(dargah)" width="70" @click="ClickLogoDargah(dargah)" :src="dargah.fizicalImageUrl" alt="..." class="rounded Pointer" :class="Dargah == dargah.id ? 'SelectedImageIcon' : ''" />
      </span>

      <!-- <img width="85" @click="Dargah=2" src="/Template/NewMenu/img/NetPaImage/Sadad.png" alt="..." class="rounded Pointer mr-2" :class="Dargah==2?'SelectedImageIcon':''">
                <img width="85" @click="Dargah=3" src="/Template/NewMenu/img/NetPaImage/Zarinpal.png" alt="..." class="rounded Pointer mr-2" :class="Dargah==3?'SelectedImageIcon':''"> -->
    </div>
    <div class="mt-3" v-for="dargah in ListDargah" :key="dargah.id">
      <span v-if="GetDay(dargah) && dargah.id == Dargah" class="text-dark">{{ dargah.persianName }}</span>
    </div>
    <div class="mt-3">
      {{ Dargah_G }}
      <slot name="ContentButtonPayment"> </slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Dargah: 0,
      ListDargah: [],
      FixVarizGhest: false,
    }
  },
  mounted() {
    this.GetListDargah()
  },
  computed: {
    Dargah_G() {
      this.$emit('GatewayCode', this.Dargah)
      this.$emit('FixVarizGhest', this.FixVarizGhest)
      return ''
    },
  },
  methods: {
    GetListDargah() {
      this.$Gateway().then((data) => {
        if (data.status == 'Ok') {
          data.data.forEach((element) => {
            if ((element.gatewayCode != null || element.gatewayCode != '') && element.isDefault == true) {
              this.Dargah = element.id
              this.FixVarizGhest = element.isFixVarizGhest
            }
          })
          this.ListDargah = data.data
        } else {
          this.$mySweetDefaultTost('عدم وجود اطلاعات', data.msg, 'warning', 2000)
        }
      })
      //
      //             var DataAxiosRow={ArryfildValue:{}}
      // DataAxiosRow.Action="GetGateway"
      //    DataAxiosRow.Method= "GET"
      //                 this.$PostData(DataAxiosRow).then((data)=>{
      //                     if (data.status=="Ok") {
      //                         data.data.forEach(element => {
      //                             if(((element.gatewayCode!=null||element.gatewayCode!="") && element.isDefault==true)) {
      //                                 this.Dargah=element.id
      //                                 this.FixVarizGhest=element.isFixVarizGhest
      //                             }
      //                         });
      //                         this.ListDargah=data.data
      //                     }
      //                     else
      //                     {
      //                         this.$mySweetDefaultTost("عدم وجود اطلاعات",data.msg, 'warning', 2000);
      //                     }
      //                 })
    },
    ClickLogoDargah(item) {
      this.Dargah = item.id
      this.FixVarizGhest = item.isFixVarizGhest
    },
    GetDay(dargah) {
      var NowDay = this.$GetJalaliDate().split('/')[2]

      if (dargah.gatewayCode != null) {
        if (NowDay >= dargah.activeDay.split('-')[0] && NowDay <= dargah.activeDay.split('-')[1]) {
          return true
        }
      }
    },
  },
}
</script>
<style scoped>
.SelectedImageIcon {
  border: 2px dashed #ff9800 !important;
}
.border-warning {
  border-bottom: 1px dashed #ff9800 !important;
}
</style>
